import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import TR from './../../Trans';
import { Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeToggleButton from '../items/ThemeToggleButton';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Error from './../items/Error';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import muvikaAttrs from './../../attrs';
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { useLocalStorage } from '../../services/useLocalStorage';
import ChooseLanguage from './../items/ChooseLanguage';
import TermsDialog from '../dialogs/TermsDialog';
import sessionStore from './../../stores/session';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import environmentStore from './../../stores/environment';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function CreateAccount() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const [, updateState] = useState();

  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const verificationCode = queryParameters.get("verification_code");

  const sessionToken = sessionStore((state) => state.sessionToken);
  const updateSession = sessionStore((state) => state.updateSession);
  const verifiedUsername = accountStore((state) => state.verifiedUsername);
  const verifyAccountLink = accountStore((state) => state.verifyAccountLink);
  const createAccount = accountStore((state) => state.createAccount);
  const isRegistered = accountStore((state) => state.isRegistered);
  const setError = messageStore((state) => state.setError);
  const clearVerifications = accountStore((state) => state.clearVerifications);
  const clearAccountStore = accountStore((state) => state.clearAll);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const isWaiting = accountStore((state) => state.isWaiting);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [language, setLanguage] = useState("");
  const [continent, setContinent] = useState("");
  const [country, setCountry] = useState(-1);
  const [countryState, setCountryState] = useState(-1);
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [areTermsAccepted, setAreTermsAccepted] = useState(false);
  const [areNewsletterAccepted, setAreNewsletterAccepted] = useState(false);


  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const [appLanguage, setAppLanguage] = useState(() => {
    const saved = localStorage.getItem(muvikaAttrs.service + "-session-language");
    const initialValue = JSON.parse(saved);
    if (initialValue) {
      setLanguage(initialValue);
    }
    return initialValue || "";
  });


  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);

  const handleOpenTermsDialog = (e) => {
    e.preventDefault();
    setIsTermsDialogOpen(true);
  };

  const handleCloseTermsDialog = () => {
    setIsTermsDialogOpen(false);
  };

  useEffect(() => {
    if (language.length > 0) {
      handleSessionLanguageChange(language);
    }
    if (!environment) {
      getEnvironment(sessionToken);
    }
    if (verificationCode) {
      verifyAccountLink(sessionToken, verificationCode);
    }
    if (environment) {
      if (environment.country_code) {
        setCountry(environment.country_code);
      }
    }
    clearVerifications();
    document.title = TR.ww_page_title;
  }, []);

  useEffect(() => {
    if (environment) {
      if (environment.country_code) {
        setCountry(environment.country_code);
      }
    }
  }, [environment]);

  const handleSessionLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    updateSession(sessionToken, lowLang);
    updateState({});
  };

  const handleCreateAccount = () => {
    if (verifiedUsername) {
      if (areTermsAccepted) {
        let newAccount = {};
        newAccount.username = verifiedUsername;
        newAccount.email = verifiedUsername;
        newAccount.firstname = firstname;
        newAccount.lastname = lastname;
        newAccount.language = language;
        console.log(country);
        newAccount.allow_newsletter = areNewsletterAccepted;
        if (country != -1) {
          newAccount.country_code = country;
          let stateIndex = environment.states_or_provinces.findIndex(x => x.country_code === country);
          if (stateIndex != -1) {
            if (countryState != -1) {
              newAccount.state_or_province_code = countryState;
            } else {
              console.log(stateIndex + " " + countryState);
              setError(sessionToken, 0, TR.cm_select_state_or_province);
              return;
            }
          }
          if (password1.length >= 8) {
            if (password1 === password2) {
              newAccount.password = password1;
              createAccount(sessionToken, newAccount, verificationCode);
            } else {
              setError(sessionToken, 0, TR.ww_passwords_must_match);
            }
          } else {
            setError(sessionToken, 0, TR.cm_password_requirements);
          }
        } else {
          setError(sessionToken, 0, TR.cm_select_your_country);
        }
      } else {
        setError(sessionToken, 0, TR.cm_check_terms_and_conditions);
      }
    } else {
      setError(sessionToken, 0, TR.ss_failed_to_create_account);
    }
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleContinentChange = (event) => {
    setContinent(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };

  const handleCountryStateChange = (event) => {
    setCountryState(event.target.value);
  };

  const handleTermsSet = (event) => {
    setAreTermsAccepted(event.target.checked);
  };

  const handleNewsletterSet = (event) => {
    setAreNewsletterAccepted(event.target.checked);
  };

  const listLanguages = () => {
    if (environment) {
      return environment.languages.map((language) => {

        return <MenuItem key={language} value={language.toLowerCase()}>{language}</MenuItem>;
      }
      );
    }
  };

  const listContinents = () => {
    if (environment) {
      return environment.continents.map((continent) =>
        <MenuItem key={continent.code} value={continent.code}>{continent.name}</MenuItem>
      );
    }
  };


  const listCountries = () => {
    if (environment) {
      return environment.countries.map((country) => {

        return <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>;
      }
      );
    }
  };

  const listCountryStates = () => {
    if (environment && country) {
      return environment.states_or_provinces.map((countryState) => {

        if (countryState.country_code === country) {
          return <MenuItem key={countryState.code} value={countryState.code}>{countryState.name}</MenuItem>;
        }
      }
      );
    }
  };

  const selectContinents = () => {
    return <Select className="muvika-select"
      onChange={handleContinentChange}
    >
      {listContinents()}
    </Select>;
  };

  const selectCountries = () => {
    return <FormGroup>
      <InputLabel>{TR.cm_country}</InputLabel>
      <Select className="muvika-select"
        value={country ? country : -1}
        onChange={handleCountryChange}
      >
        <MenuItem key={-1} value={-1}>{TR.cm_select}</MenuItem>;
        {listCountries()}
      </Select>
    </FormGroup>;
  };

  const selectCountryStates = () => {
    if (country.length > 0) {
      let isStates = environment.states_or_provinces.find(x => x.country_code === country);
      if (isStates) {
        return <FormGroup>
          <InputLabel>{TR.cm_state_or_province}</InputLabel>
          <Select className="muvika-select"
            defaultValue={-1}
            onChange={handleCountryStateChange}
          >
            <MenuItem key={-1} value={-1}>{TR.cm_select}</MenuItem>;
            {listCountryStates()}
          </Select>
        </FormGroup>;
      }
    }
  };

  const renderTermsDialog = () => {
    return <TermsDialog
      open={isTermsDialogOpen}
      onClose={handleCloseTermsDialog}
      title={TR.cm_terms_and_conditions}
      url={environment ? environment.urls.url_terms_home : ""}
    />;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleCreateAccount();
    }
  };


  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-svg" />;
    }
  };

  const renderForm = () => {
    if (environment && verifiedUsername) {
      if (!isRegistered) {
        return <ThemeProvider theme={darkTheme}>
          <Box className="muvika-createaccount-container" onKeyDown={handleKeyDown}>
            <Container component="main" className="muvika-entry-container" maxWidth="xs" onKeyDown={handleKeyDown}>
              <CssBaseline />
              <Error />
              {renderTermsDialog()}
              <Box className="muvika-entry-box">
                <ChooseLanguage environment={environment} onLanguageChange={handleSessionLanguageChange} />
                <p>
                  <a href="#/">{renderLogo()}</a>
                </p>

                <Typography sx={{ padding: "1rem" }} component="p" variant="p">
                  {TR.ww_enter_basic_account_info}
                </Typography>
                <Box component="form" noValidate sx={{ margin: 2 }}>
                  <FormGroup>
                    <Stack spacing={2}>
                      <InputLabel />
                      <InputLabel>{TR.cm_username}</InputLabel>
                      <TextField
                        sx={{ marginTop: "0 !important" }}
                        size="small"
                        defaultValue={verifiedUsername}
                        disabled
                      />
                      <InputLabel>{TR.cm_firstname}</InputLabel>
                      <TextField
                        sx={{ marginTop: "0 !important" }}
                        onChange={(e) => setFirstname(e.target.value)}
                        size="small"
                      />
                      <InputLabel>{TR.cm_lastname}</InputLabel>
                      <TextField
                        sx={{ marginTop: "0 !important" }}
                        onChange={(e) => setLastname(e.target.value)}
                        size="small"
                      />
                      <InputLabel>{TR.cm_language}</InputLabel>
                      <Select className="muvika-select"
                        label={TR.cm_language}
                        defaultValue={appLanguage}
                        onChange={handleLanguageChange}
                      >
                        {listLanguages()}
                      </Select>
                      {selectCountries()}
                      {selectCountryStates()}
                      <InputLabel>{TR.cm_new_password}</InputLabel>
                      <OutlinedInput
                        id="create-password1"
                        size="small"
                        margin="normal"
                        required
                        fullWidth
                        onChange={(e) => setPassword1(e.target.value)}
                        type={showPassword1 ? 'text' : 'password'}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword1(!showPassword1)}
                              onMouseDown={() => setShowPassword1(!showPassword1)}
                              edge="end"
                            >
                              {showPassword1 ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />

                      <InputLabel>{TR.cm_new_password_again}</InputLabel>
                      <OutlinedInput
                        id="create-password2"
                        size="small"
                        margin="normal"
                        required
                        fullWidth
                        onChange={(e) => setPassword2(e.target.value)}
                        type={showPassword2 ? 'text' : 'password'}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword2(!showPassword2)}
                              onMouseDown={() => setShowPassword2(!showPassword2)}
                              edge="end"
                            >
                              {showPassword2 ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <p className="muvika-no-margintop">
                        <FormControlLabel onChange={handleTermsSet} required control={<Checkbox />} />
                        <span>
                          {TR.cm_i_have_read_and_agree}
                          {" "}
                          <a href="#" onClick={(e) => handleOpenTermsDialog(e)} target="_blank">
                            {TR.cm_terms_and_conditions.toLocaleLowerCase()}
                          </a>
                        </span>
                      </p>
                      <p className="muvika-no-margintop">
                        <FormControlLabel onChange={handleNewsletterSet} required control={<Checkbox />} />
                        <span>
                          {TR.cm_allow_newsletter}
                        </span>
                      </p>
                    </Stack>
                  </FormGroup>
                </Box>
                <Stack direction="row" spacing={6} justifyContent="center">
                  <Button href="#/startregister" variant="text" color="secondary">{TR.cm_cancel}</Button>
                  <Button
                    disabled={isWaiting}
                    variant="text"
                    color="success"
                    onClick={handleCreateAccount}
                  >
                    {TR.cm_save}
                  </Button>
                </Stack>
                <ThemeToggleButton />
              </Box>
            </Container>
          </Box>
        </ThemeProvider >;
      } else {
        return <Navigate to="/newaccount" />;
      }
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
  overscroll-behavior:auto !important;
    overflow-y:scroll !important;
  }
  
  main {
    overscroll-behavior:unset !important;
    overflow-y:scroll !important;
  }
`;

const overflowStyleTerms = `
  body {
  overscroll-behavior:auto !important;
    overflow-y:auto !important;
  }
  
  main {
    overscroll-behavior:auto !important;
    overflow-y:auto !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
  overscroll-behavior:auto !important;
    overflow-y:auto !important;
  }
  
  main {
    overscroll-behavior:auto !important;
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {isTermsDialogOpen ? overflowStyleTerms : overflowStyle}
      </style>;
    }
  };

  return (
    <div style={{ overflowY: "scroll !important", overscrollBehavior:"auto !important" }}>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      {renderOverflowStyle()}
      {renderForm()}
    </div>
  );
}

export default CreateAccount;
